import React, { useState, useEffect } from "react";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { Box, Typography, Tooltip, IconButton } from "@mui/material";
import CustomPagination from "../../components/CustomPagination";
import { UseAddOrder } from "./UseAddOrder";
import DeleteIcon from "@mui/icons-material/Delete";
import { toMoney } from "../../util/Utils";

export default function DetailsGrid(props) {
  const { RemoveOrder } = UseAddOrder();
  const [row, setRow] = useState();
  const [pageState, setPageState] = useState({
    page: 1,
  });

  useEffect(() => {
    if (props.row && props.row.products) {
      props.row.products.map((m) => {
        m.totalCost = m.cost * m.orderCount;
        return m;
      });
      setRow(props.row);
    } else {
      setRow();
    }
  }, [props.row]);

  const columns = [
    {
      field: "id",
      width: 90,
      align: "center",
      headerAlign: "center",
      headerName: "کد محصول",
      hide: true,
    },
    {
      field: "productID",
      width: 90,
      align: "center",
      headerAlign: "center",
      headerName: "کد محصول",
    },
    {
      field: "productName",
      width: 300,
      align: "left",
      headerAlign: "center",
      headerName: "نام محصول",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.productName}
          </Typography>
        );
      },
    },
    {
      field: "orginalCost",
      headerName: "قیمت",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography>
            {cellValues.row.orginalCost
              ? toMoney(cellValues.row.orginalCost)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "cost",
      headerName: "قیمت با تخفیف",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography>
            {cellValues.row.cost ? toMoney(cellValues.row.cost) : 0}
          </Typography>
        );
      },
    },
    {
      field: "orderCount",
      headerName: "تعداد",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "totalCost",
      headerName: "مجموع",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography>
            {cellValues.row.totalCost ? toMoney(cellValues.row.totalCost) : 0}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 90,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="Delete">
            <IconButton
              onClick={() => {
                let body = {
                  OrderId: props.orderID,
                  Productid: cellValues.row.productID,
                };
                RemoveOrder(body, (callback) => {
                  callback.products &&
                    callback.products.map((m) => {
                      m.totalCost = m.cost * m.orderCount;
                      return m;
                    });
                  props.setExpanded("panel1");
                  props.setRow(callback);
                });
              }}
            >
              <DeleteIcon sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "25rem", mb: 3 }}>
      <DataGrid
        className="ltr-grid"
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        pageSize={20}
        pagination
        page={pageState.page - 1}
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={
          row && row.products && row.products.length ? row.products.length : 1
        }
        rows={row && row.products !== null ? row.products : []}
        enableRangeSelection={true}
        disableColumnMenu
        disableVirtualization
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            nofab: true,
            // noPage: true,
            isLtr: true,
            rowCount:
              row && row.products && row.products.length
                ? row.products.length
                : "",
          },
        }}
      />
    </Box>
  );
}
